import _ from "lodash";
import React from "react";
import classNames from "classnames";
import { MODE_ASSESSMENT_VIEW } from "Worksheet/modules/WorksheetConstants";
import { getRethumbUrl } from "Utils";
import {
  PLACEHOLDER_SQUARE_IMAGE,
  PLACEHOLDER_SQUARE_IMAGE_COUNT,
} from "Constants";
import { getQuestionsCountLabel } from "Worksheet/modules/WorksheetUtils";

import Worksheet from "Worksheet";
import { Tag } from "@toddle-edu/ds-web";
import classes from "./WorksheetPreview.scss";

const WorksheetPreview = ({
  t,
  id,
  worksheetItem,
  assessmentId,
  imageUrl,
  portalType,
  importFromToddleLibrary,
}) => {
  const questionTypeWiseCount = _.get(worksheetItem, "questionTypeWiseCount");
  const worksheetQuestionsCountLabel = getQuestionsCountLabel({
    t,
    questionTypeWiseCount,
  });
  return (
    <div className={classNames("w-full", classes.container)}>
      <Header
        id={id}
        t={t}
        title={_.get(worksheetItem, "title", "")}
        questionCount={_.get(worksheetItem, "questionCount", 0)}
        totalMarks={_.get(worksheetItem, "totalMarks", 0)}
        worksheetItem={worksheetItem}
        imageUrl={imageUrl}
        worksheetQuestionsCountLabel={worksheetQuestionsCountLabel}
      />
      <div className={classes.worksheetContainer}>
        <Worksheet
          mode={MODE_ASSESSMENT_VIEW}
          parentType={"ASSESSMENT"}
          parentId={assessmentId}
          isFromLibrary={true}
          portalType={portalType}
          importFromToddleLibrary={importFromToddleLibrary}
        />
      </div>
    </div>
  );
};

const Header = React.memo(
  ({
    t,
    title,
    questionCount,
    totalMarks,
    imageUrl,
    id,
    worksheetQuestionsCountLabel,
  }) => {
    const rethumpUrl = `url(${getRethumbUrl({
      width: 512,
      height: 384,
      imageUrl:
        imageUrl ||
        PLACEHOLDER_SQUARE_IMAGE[id % PLACEHOLDER_SQUARE_IMAGE_COUNT],
      fitIn: true,
    })})`;

    return (
      <div className={classes.upperCon}>
        <div
          className={classes.imageContainer}
          style={{
            backgroundImage: rethumpUrl,
          }}
        ></div>
        <div className={classes.BFlexDivCol}>
          <div className={classNames("heading-4", classes.title)}>
            {title}
            <Tag
              _legacy_size="xx-small"
              size="small"
              color={"yellow"}
              dsVersion="2.0"
            >
              {`${t("common:mark_with_number_plural", {
                count: totalMarks,
              })}`}
            </Tag>
          </div>
          <div className={"text-body-2"}>
            {t("toddleLibrary:question_with_count", {
              count: questionCount,
            })}
          </div>
          <div
            className={classNames(classes.questionsDescription, "text-body-2")}
          >
            {worksheetQuestionsCountLabel}
          </div>
        </div>
      </div>
    );
  }
);

Header.displayName = "Header";

export default WorksheetPreview;
